module.exports = __webpack_public_path__ + "img/kaiserschmarrn.ff99199a.png";